var map = {
	"./A new images/1D8rEtePR0CUxkyiPwP_8g.jpeg": 5048,
	"./A new images/3d-building-icon_1322386-15664.jpg": 9740,
	"./A new images/ETm8qANbQmWgNbrswUM4bQ.jpeg": 3739,
	"./A new images/EVdqBVDMSoWt5gVySh4sGg.jpeg": 1619,
	"./A new images/GMR Logo Final-01.png": 5104,
	"./A new images/HwN6h43WQyCaoZd4QDi0Cw.jpeg": 1832,
	"./A new images/NM_12int.png": 9810,
	"./A new images/R7-RPJi6R6KtiksA59bcow.jpeg": 6382,
	"./A new images/RMdtuYVMRSeEltnPl7VSQw.jpeg": 3376,
	"./A new images/SNM0SQnnSRObj7XKJBQ8WA.jpeg": 6679,
	"./A new images/Screenshot 2024-10-11 182814.png": 6688,
	"./A new images/Screenshot 2024-10-11 182921.png": 5890,
	"./A new images/UQDdCiUiRsKT1p9oGAH2Kw.jpeg": 6142,
	"./A new images/_DRYOT2LR7es4xYcB4vgpw.jpeg": 5874,
	"./A new images/architecture-project-showing-different-design-phases-from-handmade-rough-sketch-construction_1199132-218887.jpg": 6485,
	"./A new images/b81JUqyzTKKrRCRCGfJ_OA.jpeg": 3982,
	"./A new images/bdtkL6jwRky2T_zVgrkPlg.jpeg": 8214,
	"./A new images/c10i4dWoTxCsSb3QA9N75w.jpeg": 3594,
	"./A new images/e15aeb_bc5202af6b4c4c41b2afbc1dc3a6d9d3~mv2.gif": 1436,
	"./A new images/e2W3-VhEQR-klPWhvT7X9g.jpeg": 1972,
	"./A new images/eNYrDVHuTpW-oTN0PPDclw.jpeg": 578,
	"./A new images/istockphoto-1241693598-640_adpp_is.mp4": 7309,
	"./A new images/kSezW9GjTSyD-40FUm3EOg.jpeg": 6109,
	"./A new images/oD_o2Q3DTUqqUyoQ9mQofg.jpeg": 9569,
	"./A new images/pexels-heyho-6538934.jpg": 5318,
	"./A new images/pexels-heyho-7005295.jpg": 3437,
	"./A new images/pexels-israel-elizondo-fotografia-1755199571-28843334.jpg": 4452,
	"./A new images/pexels-tara-winstead-7723720.jpg": 6346,
	"./A new images/slide1.gif": 6616,
	"./A new images/uMYxpflSTKK4ae2ByGoIGg.jpeg": 8183,
	"./A new images/unVoNKIdQjaUgoyncCVIkQ.jpeg": 8747,
	"./A new images/vecteezy_a-city-aerial-flyover-3d-animation_1623493.mp4": 2908,
	"./A new images/vecteezy_animated-blueprints-3d-building-models-moving_48860863.gif": 2701,
	"./A new images/vrCwcgJMQRef6r7sdLzsEw.jpeg": 4130,
	"./A new images/vx05PkQoQNCRlZhZ0YiqHQ.jpeg": 4927,
	"./A new images/zsDf5lKSQm2dIur4gAlgnQ.jpeg": 4402,
	"./A new images/zzsu1qKVSxGIHCC_6zCrag.jpeg": 5627,
	"./LOD-100.jpg": 4984,
	"./LOD-200.jpg": 2642,
	"./LOD-300.jpg": 1567,
	"./LOD-400.jpg": 3527,
	"./LOD-500.jpg": 5066,
	"./about-slider/1-ab.jpg": 9250,
	"./about-slider/1.jpg": 9170,
	"./about-slider/2.jpg": 8166,
	"./about-slider/3.jpg": 1101,
	"./about-slider/4.jpg": 3224,
	"./about-slider/5.jpg": 461,
	"./background/MBzQ_nNsTCK5SkWWPV-IaQ.jpeg": 6910,
	"./background/bg-1.jpg": 78,
	"./background/bg-11.jpg": 6644,
	"./background/bg-12.jpg": 1658,
	"./background/bg-2.jpg": 6848,
	"./background/bg-22.jpg": 7813,
	"./background/bg-4.png": 6780,
	"./background/bg-5.png": 670,
	"./background/bg-6.png": 7217,
	"./background/bg-8.jpg": 7784,
	"./background/bg-form.jpg": 4969,
	"./background/bg-map.png": 3727,
	"./background/bg5.gif": 1947,
	"./background/bg5.jpeg": 1492,
	"./background/bg5.jpg": 7925,
	"./background/bg5.webp": 3303,
	"./background/bg55.jpg": 4862,
	"./background/bg6.jpg": 3008,
	"./background/cross-line.png": 5852,
	"./background/cross-line2.png": 2091,
	"./background/f-bg.jpg": 5598,
	"./background/f-bg1.jpg": 8361,
	"./background/nesGnnSZTyClT0zglidK8A.jpeg": 6550,
	"./background/xx8i0C1pQ1yq-9VyP09v7A.jpeg": 2068,
	"./banner/1.jpg": 343,
	"./banner/10.jpg": 4291,
	"./banner/2.jpg": 9922,
	"./banner/3.jpg": 3215,
	"./banner/4.jpg": 8621,
	"./banner/5.jpg": 5308,
	"./banner/6.jpg": 2062,
	"./banner/6.png": 9766,
	"./banner/66.jpg": 6146,
	"./banner/66.png": 8823,
	"./banner/7.jpg": 8249,
	"./banner/8.jpg": 7823,
	"./banner/9.jpg": 9300,
	"./blog/blog-grid/pic1.jpg": 5015,
	"./blog/blog-grid/pic2.jpg": 9452,
	"./blog/blog-grid/pic3.jpg": 6986,
	"./blog/blog-grid/pic4.jpg": 4835,
	"./blog/blog-grid/pic5.jpg": 9378,
	"./blog/blog-grid/pic6.jpg": 4646,
	"./blog/blog-grid/pic7.jpg": 9166,
	"./blog/blog-grid/pic8.jpg": 4684,
	"./blog/default/thum1.jpg": 9496,
	"./blog/default/thum2.jpg": 4461,
	"./blog/default/thum3.jpg": 2521,
	"./blog/default/thum4.jpg": 2349,
	"./blog/default/thum5.jpg": 4975,
	"./blog/default/thum6.jpg": 9542,
	"./blog/default/thum7.jpg": 9733,
	"./blog/default/thum8.jpg": 5818,
	"./blog/default/thum9.jpg": 2857,
	"./blog/portrait/pic1.jpg": 1889,
	"./blog/portrait/pic10.jpg": 8150,
	"./blog/portrait/pic2.jpg": 656,
	"./blog/portrait/pic3.jpg": 5422,
	"./blog/portrait/pic4.jpg": 6212,
	"./blog/portrait/pic5.jpg": 2434,
	"./blog/portrait/pic6.jpg": 6638,
	"./blog/portrait/pic7.jpg": 8085,
	"./blog/portrait/pic8.jpg": 6939,
	"./blog/portrait/pic9.jpg": 6545,
	"./blog/recent-blog/pic1.jpg": 9070,
	"./blog/recent-blog/pic2.jpg": 5751,
	"./blog/recent-blog/pic3.jpg": 4274,
	"./cart/pic-1.jpg": 6432,
	"./cart/pic-2.jpg": 6121,
	"./cart/pic-3.jpg": 5606,
	"./client-logo/1.png": 153,
	"./client-logo/2.png": 990,
	"./client-logo/3.png": 1289,
	"./client-logo/4.png": 5139,
	"./client-logo/5.png": 6584,
	"./client-logo/6.png": 7458,
	"./client-logo/7.png": 5022,
	"./client-logo/logo1.png": 5187,
	"./client-logo/logo2.png": 6196,
	"./client-logo/logo3.png": 9503,
	"./client-logo/logo4.png": 8776,
	"./client-logo/logo5.png": 3756,
	"./client-logo/logo6.png": 8544,
	"./client-logo/logo7.png": 8315,
	"./client-logo/logo8.png": 3687,
	"./error-404.png": 751,
	"./favicon.ico": 9016,
	"./favicon.png": 7457,
	"./gallery/pic1.jpg": 9649,
	"./gallery/pic2.jpg": 4745,
	"./gallery/pic3.jpg": 1866,
	"./gallery/pic4.jpg": 7837,
	"./gallery/pic5.jpg": 5914,
	"./gallery/pic55.jpg": 7028,
	"./gallery/pic6.jpg": 1391,
	"./gallery/pic7.jpg": 7624,
	"./gallery/pic8.jpg": 4195,
	"./gallery/pic9.jpg": 9691,
	"./gallery/portrait/pic1.jpg": 312,
	"./gallery/portrait/pic2.jpg": 3257,
	"./gallery/portrait/pic3.jpg": 4083,
	"./gallery/portrait/pic4.jpg": 538,
	"./gallery/portrait/pic5.jpg": 3379,
	"./gallery/portrait/pic6.jpg": 9692,
	"./gallery/portrait/pic7.jpg": 6310,
	"./gallery/thumb/pic1.jpg": 2355,
	"./gallery/thumb/pic2.jpg": 4482,
	"./gallery/thumb/pic3.jpg": 1712,
	"./gallery/thumb/pic4.jpg": 1098,
	"./gallery/thumb/pic5.jpg": 7945,
	"./gallery/thumb/pic6.jpg": 644,
	"./gallery/thumb/pic7.jpg": 931,
	"./gallery/thumb/pic8.jpg": 9018,
	"./gallery/thumb/pic9.jpg": 7093,
	"./logo-1.png": 2096,
	"./logo-11.png": 6168,
	"./logo-light.png": 9731,
	"./logo-light11.png": 126,
	"./main-slider/slider1/slide11.jpg": 4590,
	"./main-slider/slider1/slide2.jpg": 8537,
	"./main-slider/slider1/slide3.jpg": 9725,
	"./main-slider/slider2/SNM0SQnnSRObj7XKJBQ8WA.jpeg": 3652,
	"./main-slider/slider2/_DRYOT2LR7es4xYcB4vgpw.jpeg": 3013,
	"./main-slider/slider2/old/slide1.gif": 1704,
	"./main-slider/slider2/old/slide1.jpg": 494,
	"./main-slider/slider2/old/slide1.mp4": 9763,
	"./main-slider/slider2/old/slide11.jpg": 8142,
	"./main-slider/slider2/old/slide111.jpg": 6166,
	"./main-slider/slider2/old/slide2.jpg": 7263,
	"./main-slider/slider2/old/slide222.jpg": 7524,
	"./main-slider/slider2/old/slide3.jpg": 5283,
	"./main-slider/slider2/old/slide31.jpg": 4669,
	"./main-slider/slider2/old/slide4.jpg": 9030,
	"./main-slider/slider2/old/slide41.jpg": 675,
	"./main-slider/slider2/slide1.jpeg": 4453,
	"./main-slider/slider2/slide2.jpeg": 8225,
	"./main-slider/slider2/slide3.jpeg": 7116,
	"./main-slider/slider3/slide1.jpg": 8379,
	"./main-slider/slider3/slide2.jpg": 2829,
	"./main-slider/slider3/slide3.jpg": 3167,
	"./main-slider/slider5/slide1-sk.jpg": 2413,
	"./main-slider/slider5/slide1.jpg": 2405,
	"./main-slider/slider5/slide2-sk.jpg": 5281,
	"./main-slider/slider5/slide2.jpg": 6978,
	"./marker.png": 651,
	"./our-history/1.jpg": 730,
	"./our-history/2.jpg": 1895,
	"./our-history/3.jpg": 3784,
	"./our-history/4.jpg": 4413,
	"./our-history/5.jpg": 2269,
	"./our-history/6.jpg": 5275,
	"./our-history/7.jpg": 8703,
	"./our-history/8.jpg": 3546,
	"./our-team5/1.jpg": 8477,
	"./our-team5/2.jpg": 7325,
	"./our-team5/3.jpg": 7155,
	"./our-team5/4.jpg": 7036,
	"./our-team5/5.jpg": 2262,
	"./our-team5/6.jpg": 3098,
	"./our-team5/7.jpg": 743,
	"./our-team5/8.jpg": 1198,
	"./pic1.png": 8043,
	"./pic11.jpg": 6282,
	"./pic2.png": 5581,
	"./pic22.jpg": 8156,
	"./pic3.png": 7294,
	"./pic33.jpg": 3309,
	"./pic4.png": 7599,
	"./pic5.png": 2690,
	"./pic6.png": 6900,
	"./pic7.png": 5789,
	"./pic8.png": 4857,
	"./pic9.png": 1553,
	"./products/pic-1.jpg": 9309,
	"./products/pic-2.jpg": 7146,
	"./products/pic-3.jpg": 6887,
	"./products/pic-4.jpg": 8816,
	"./products/pic-5.jpg": 1838,
	"./products/pic-6.jpg": 4976,
	"./products/pic-7.jpg": 1767,
	"./products/pic-8.jpg": 2383,
	"./products/thumb/pic-1.jpg": 225,
	"./products/thumb/pic-2.jpg": 2254,
	"./products/thumb/pic-3.jpg": 3978,
	"./products/thumb/pic-4.jpg": 139,
	"./products/thumb/pic-5.jpg": 5536,
	"./projects/portrait/pic1.jpg": 2385,
	"./projects/portrait/pic10.jpg": 3981,
	"./projects/portrait/pic2.jpg": 4752,
	"./projects/portrait/pic3.jpg": 5707,
	"./projects/portrait/pic4.jpg": 3348,
	"./projects/portrait/pic5.jpg": 7846,
	"./projects/portrait/pic6.jpg": 5525,
	"./projects/portrait/pic7.jpg": 5395,
	"./projects/portrait/pic8.jpg": 2246,
	"./projects/portrait/pic9.jpg": 2905,
	"./projects/square/pic1.jpg": 7482,
	"./projects/square/pic10.jpg": 1285,
	"./projects/square/pic2.jpg": 7398,
	"./projects/square/pic3.jpg": 6886,
	"./projects/square/pic4.jpg": 5633,
	"./projects/square/pic5.jpg": 7881,
	"./projects/square/pic6.jpg": 9620,
	"./projects/square/pic7.jpg": 3267,
	"./projects/square/pic8.jpg": 1874,
	"./projects/square/pic9.jpg": 897,
	"./services/architectural-bim.png": 8967,
	"./services/cad-to-bim.png": 9463,
	"./services/clash-detection.png": 3478,
	"./services/mepfp.png": 3074,
	"./services/quantity-takeoffs.png": 79,
	"./services/revit-family.png": 4317,
	"./services/scan-to-bim.webp": 9330,
	"./services/scheduling-simulation.png": 2201,
	"./services/service-projects/1.jpg": 4213,
	"./services/service-projects/10.jpg": 3028,
	"./services/service-projects/11.jpg": 6350,
	"./services/service-projects/2.jpg": 9699,
	"./services/service-projects/22.jpg": 7256,
	"./services/service-projects/3.jpg": 8843,
	"./services/service-projects/33 (1).jpg": 1582,
	"./services/service-projects/4.jpg": 1383,
	"./services/service-projects/44.jpg": 2788,
	"./services/service-projects/5.jpg": 9098,
	"./services/service-projects/55.jpg": 2944,
	"./services/service-projects/6.jpg": 2803,
	"./services/service-projects/66.jpg": 3162,
	"./services/service-projects/7.jpg": 451,
	"./services/service-projects/77.jpg": 4803,
	"./services/service-projects/8.jpg": 1124,
	"./services/service-projects/88.jpg": 5257,
	"./services/service-projects/9.jpg": 688,
	"./services/service-projects/RMdtuYVMRSeEltnPl7VSQw.jpeg": 6299,
	"./services/service-projects/b81JUqyzTKKrRCRCGfJ_OA.jpeg": 9709,
	"./services/structural-bim.png": 2354,
	"./testimonials/pic1.jpg": 3211,
	"./testimonials/pic11.jpg": 3263,
	"./testimonials/pic2.jpg": 7343,
	"./testimonials/pic22.jpg": 1154,
	"./testimonials/pic3.jpg": 3308,
	"./testimonials/pic4.jpg": 3270,
	"./video-bg.jpg": 7988,
	"./video-bg11.jpg": 3259,
	"./video/mission.mp4": 9843,
	"./video/vid.gif": 838,
	"./video/vid.mp4": 5085,
	"./video/vid1.mp4": 3313
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6303;